__turbopack_context__.v({
  "bufferedBar": "VideoJS-module__hfOo4a__bufferedBar",
  "centerPlayButton": "VideoJS-module__hfOo4a__centerPlayButton",
  "controlBar": "VideoJS-module__hfOo4a__controlBar",
  "controlButton": "VideoJS-module__hfOo4a__controlButton",
  "controlsGroup": "VideoJS-module__hfOo4a__controlsGroup",
  "controlsOverlay": "VideoJS-module__hfOo4a__controlsOverlay",
  "controlsRow": "VideoJS-module__hfOo4a__controlsRow",
  "playButton": "VideoJS-module__hfOo4a__playButton",
  "progressBar": "VideoJS-module__hfOo4a__progressBar",
  "progressBarContainer": "VideoJS-module__hfOo4a__progressBarContainer",
  "progressBarRow": "VideoJS-module__hfOo4a__progressBarRow",
  "timeDisplay": "VideoJS-module__hfOo4a__timeDisplay",
  "videoContainer": "VideoJS-module__hfOo4a__videoContainer",
  "volumeContainer": "VideoJS-module__hfOo4a__volumeContainer",
  "volumeSlider": "VideoJS-module__hfOo4a__volumeSlider",
});
